import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Support from "./sections/Support";
import Philosophy from "./sections/Philosophy";
import Standards from "./sections/Standards";
import Roadmap from "./sections/Roadmap";
import Voices from "./sections/Voices";
import Ready from "./sections/Ready";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Support />
      <Philosophy />
      <Standards />
      <Roadmap />
      <Voices />
      <Ready />
      <Footer />
    </div>;
}